<template>
  <div>
    <form>
      <!-- begin invoice -->
      <div class="invoice">
        <!-- begin invoice-content -->
        <div class="invoice-content">
          <!-- begin invoice-price -->
          <div class="invoice-price">
            <div class="invoice-price-left">
              <div class="invoice-price-row" style="width: 100%">
                <div class="sub-price" style="width: 30%; margin-top: -8px">
                  <small>{{ $t('martSale.subtotal') }}</small>
                  <span class="text-inverse">
                    {{ defaultCrrency }}
                    {{ data ? data.sub_total : 0 | format_number }}
                  </span>
                </div>

                <div class="sub-price text-center" style="width: 170px">
                  <small>{{ $t('martSale.discount') }}</small>

                  <b-input-group size="sm">
                    <b-input-group-prepend is-text>
                      <input
                        type="radio"
                        v-model="model.discount_type"
                        id="dolar"
                        :value="defaultCrrencySign"
                      />
                      &nbsp;{{ defaultCrrencySign }}
                    </b-input-group-prepend>

                    <b-form-input
                      v-model.number="model.discount_rate"
                      class="text-center"
                      @input="calculate"
                    ></b-form-input>

                    <b-input-group-prepend is-text for="percentage">
                      <input
                        type="radio"
                        v-model="model.discount_type"
                        id="percentage"
                        :value="'%'"
                      />
                      &nbsp;%
                    </b-input-group-prepend>
                  </b-input-group>
                </div>

                <div
                  class="sub-price text-right"
                  style="width: 35%; margin-top: -8px"
                >
                  <small>
                    {{ $t('martSale.vat') }}
                    {{ vatRate ? '(' + vatRate + '%)' : '' }}
                  </small>

                  <span class="text-inverse">
                    {{ defaultCrrency }}
                    {{ model.vat_amount | format_number }}
                  </span>
                </div>
              </div>
            </div>

            <div class="invoice-price-right" style="background: #808b96">
              <small>{{ $t('martSale.total') }}</small>

              <span class="f-w-600">
                {{ defaultCrrency }}
                {{ model.grand_total | format_number }}
              </span>
            </div>
          </div>

          <br />

          <div class="payment">
            <label class="col-form-label">
              {{ $t('martSale.cashPayment') }}
            </label>

            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input
                    ref="paid_in_default_currency"
                    type="number"
                    class="form__field"
                    :placeholder="$t('martSale.cashPayment') + ' THB'"
                    v-model.number="paid_in_default_currency"
                    min="0"
                    @input="calculate"
                  />

                  <label for="paid_in_default_currency" class="form__label">
                    {{ $t('martSale.cashIn') }} THB
                  </label>
                </div>
              </div>

              <div class="invoice-price-right">
                <span
                  class="f-w-600 text-success"
                  :class="{
                    'text-danger': change_in_default_currency < 0
                  }"
                >
                  THB
                  {{ change_in_default_currency | format_number }}
                </span>
              </div>
            </div>

            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input
                    type="number"
                    class="form__field"
                    :placeholder="$t('martSale.cashPayment') + ' KHR'"
                    v-model.number="paid_in_khr"
                    min="0"
                    @input="calculate"
                  />

                  <label for="paid_in_khr" class="form__label">
                    {{ $t('martSale.cashIn') }} KHR
                  </label>
                </div>
              </div>

              <div class="invoice-price-right">
                <span
                  class="f-w-600 text-success"
                  :class="{
                    'text-danger': change_in_riel < 0
                  }"
                >
                  KHR
                  {{ change_in_riel | format_number }}
                </span>
              </div>
            </div>
            <div class="invoice-price">
              <div class="invoice-price-left">
                <div class="form__group field">
                  <input
                    type="number"
                    class="form__field"
                    :placeholder="$t('martSale.cashPayment') + ' USD'"
                    v-model.number="paid_in_usd"
                    min="0"
                    @input="calculate"
                  />

                  <label for="paid_in_usd" class="form__label">
                    {{ $t('martSale.cashIn') }} USD
                  </label>
                </div>
              </div>

              <div class="invoice-price-right">
                <span
                  class="f-w-600 text-success"
                  :class="{
                    'text-danger': change_in_usd < 0
                  }"
                >
                  USD
                  {{ change_in_usd | format_number }}
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-2 col-form-label">
                + {{ $t('martSale.otherPayment') }}
              </label>

              <div class="col-md-5">
                <ul class="list-inline payment-type">
                  <li :class="{ active: isActive == 'coupon' }">
                    <a
                      href="#"
                      :title="$t('martSale.coupon')"
                      @click="
                        ;[
                          (isActive = 'coupon'),
                          (model.paid_in_credit_card = null),
                          (model.payment_method_id = 1)
                        ]
                        onPaymentMethodChange()
                      "
                    >
                      <i class="fab fa-contao"></i>
                    </a>
                  </li>

                  <li :class="{ active: isActive == 'credit_card' }">
                    <a
                      href="#"
                      :title="$t('martSale.creditCard')"
                      @click="
                        ;[
                          (isActive = 'credit_card'),
                          (model.paid_in_coupon = null),
                          (model.payment_method_id = 4)
                        ]
                        onPaymentMethodChange()
                      "
                    >
                      <i class="far fa-credit-card"></i>
                    </a>
                  </li>

                  <li :class="{ active: isActive == 'bank_transfer' }">
                    <a
                      href="#"
                      :title="$t('martSale.bankTransfer')"
                      @click="
                        ;[
                          (isActive = 'bank_transfer'),
                          (model.bank_transfer = null),
                          (model.payment_method_id = 3)
                        ]
                        onPaymentMethodChange()
                      "
                    >
                      <i class="fa fa-university"></i>
                    </a>
                  </li>

                  <li :class="{ active: isActive == 'paid_by_cheque' }">
                    <a
                      href="#"
                      :title="$t('martSale.paidByCheque')"
                      @click="
                        ;[
                          (isActive = 'paid_by_cheque'),
                          (model.paid_by_cheque = null),
                          (model.payment_method_id = 2)
                        ]
                        onPaymentMethodChange()
                      "
                    >
                      <i class="fas fa-money-check-alt"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-12">
                <div class="invoice-price" v-if="isActive != 'coupon'">
                  <div class="invoice-price-left">
                    <a-input-group compact>
                      <a-input
                        v-model="model.bank_name"
                        style="
                          width: 23%;
                          font-weight: 800;
                          text-align: center;
                        "
                        disabled
                      />

                      <a-input
                        v-model="bankAccountNumber"
                        style="width: 77%; font-weight: 800"
                        disabled
                      />
                    </a-input-group>

                    <div class="validate" v-if="errors.has('account_name')">
                      {{ errors.first('bank_name') }}
                    </div>
                  </div>

                  <div class="invoice-price-right-gray"></div>
                </div>
                <div class="invoice-price" v-if="isActive == 'coupon'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.couponInUsd')"
                        min="0"
                        v-model.number="model.paid_in_coupon"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.couponInUsd') }}
                      </label>
                    </div>
                  </div>

                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert
                        v-if="changeInUsdErrors.length > 0"
                        message="Payment"
                        :description="changeInUsdErrors[0]"
                        type="error"
                        show-icon
                        closable
                      />
                    </div>
                  </div>
                </div>

                <div class="ts-mt-4">
                  <a-radio-group
                    name="paperSize"
                    default-value="a5"
                    v-model="model.paperSize"
                  >
                    <a-radio value="a5">
                      A5
                    </a-radio>

                    <a-radio value="e_receipt">
                      Receipt
                    </a-radio>
                  </a-radio-group>
                </div>
                <div class="invoice-price" v-if="isActive == 'credit_card'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.creditCardInUsd')"
                        min="0"
                        v-model.number="model.paid_in_credit_card"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.creditCardInUsd') }}
                      </label>
                    </div>
                  </div>

                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert
                        v-if="changeInUsdErrors.length > 0"
                        message="Payment"
                        :description="changeInUsdErrors[0]"
                        type="error"
                        show-icon
                        closable
                      />
                    </div>
                  </div>
                </div>

                <div class="invoice-price" v-if="isActive == 'bank_transfer'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.bankTransferInUsd')"
                        min="0"
                        v-model.number="model.bank_transfer"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.bankTransferInUsd') }}
                      </label>
                    </div>

                    <div class="form__group field">
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.bankTransferInRiel')"
                        min="0"
                        v-model.number="model.bank_transfer_riel"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.bankTransferInRiel') }}
                      </label>
                    </div>

                    <div
                      class="form__group field"
                      v-if="defaultCrrency == 'THB'"
                    >
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.bankTransferInBath')"
                        min="0"
                        v-model.number="model.bank_transfer_thb"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.bankTransferInBath') }}
                      </label>
                    </div>
                  </div>

                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert
                        v-if="changeInUsdErrors.length > 0"
                        message="Payment"
                        :description="changeInUsdErrors[0]"
                        type="error"
                        show-icon
                        closable
                      />
                    </div>
                  </div>
                </div>

                <div class="invoice-price" v-if="isActive == 'paid_by_cheque'">
                  <div class="invoice-price-left">
                    <div class="form__group field">
                      <input
                        type="number"
                        class="form__field"
                        :placeholder="$t('martSale.paidByChequeInUsd')"
                        min="0"
                        v-model.number="model.paid_by_cheque"
                        @input="calculate"
                      />

                      <label for="name" class="form__label">
                        {{ $t('martSale.paidByChequeInUsd') }}
                      </label>
                    </div>
                  </div>

                  <div class="invoice-price-right-gray">
                    <div class="ts-w-full mt-1">
                      <a-alert
                        v-if="changeInUsdErrors.length > 0"
                        message="Payment"
                        :description="changeInUsdErrors[0]"
                        type="error"
                        show-icon
                        closable
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end invoice-content -->
      </div>
      <!-- end invoice -->

      <!-- begin invoice-footer -->
      <div class="invoice-footer">
        <div class="row">
          <div class="col-lg-6">
            <div style="padding-left: 20px">
              <ts-checkbox v-model="model.is_city_ledger">
                {{ $t('martSale.cityLedger') }}
              </ts-checkbox>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="btn-row pull-right">
              <ts-button
                class="btn btn-default"
                :disabled="waiting"
                @click="$emit('close')"
              >
                {{ $t('cancel') }}
              </ts-button>

              <ts-button
                type="submit"
                @click.prevent="bill"
                :waiting="waiting"
                class="btn btn-success btn-lg"
              >
                <i v-if="!waiting" class="fas fa-check fa-fw fa-lg"></i>

                {{ $t('martSale.bill') }}
              </ts-button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <a-modal
      width="500px"
      v-model="show_bank"
      centered
      :title="titleName"
      :maskClosable="false"
      :okText="$t('confirm')"
      :cancelText="$t('cancel')"
      :cancelButtonProps="{
        class: 'btn ts-whitespace-no-wrap btn-default'
      }"
      style="top: 3vh"
      :zIndex="1040"
      :closable="true"
      @cancel="onCanel"
      @ok="onOk"
      :waiting="waiting"
    >
      <div>
        <div class="row">
          <label class="required col-lg-12">
            {{ $t('wholesale.bank') }}
          </label>

          <a-radio-group
            v-model="model.bank_name"
            @change="bankNameChange"
            class="col-lg-12"
            size="large"
          >
            <a-radio-button
              v-for="(record, index) in bankNameOptions"
              :key="index"
              :value="record.label"
            >
              {{ record.label }}
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>

      <div>
        <div class="row">
          <label class="required col-lg-12">
            {{ $t('wholesale.account') }}
          </label>

          <a-radio-group
            v-model="model.account_number"
            @change="accountChange"
            class="col-lg-12"
            size="large"
          >
            <a-radio-button
              v-for="(record, index) in accountOptions"
              :key="index"
              :value="record.value"
            >
              {{ record.label }}
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { required, minValue } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'checkBill',

  props: ['data'],

  data() {
    return {
      show_bank: false,

      model: {
        stock_out_id: null,
        customer_id: null,

        paid_in_riel: null,
        paid_in_usd: null,
        paid_in_thb: null,

        paid_in_coupon: null,
        paid_in_credit_card: null,

        change_in_riel: null,
        change_in_usd: 0,
        change_in_thb: null,

        sub_total: null,
        discount_type: '%',
        discount_rate: null,
        discount_amount: null,

        total_after_discount: null,

        vat_rate: 0,
        vat_amount: 0,

        grand_total: 0,

        is_city_ledger: false,

        products: [],

        payment_method_id: 1,

        bank_name: null,
        account_number: null,
        account_name: null,

        bank_transfer: null,
        paid_by_cheque: null,

        bank_transfer_riel: null,
        bank_transfer_thb: null,

        paperSize: 'e_receipt',
        template: 'en',

        fx_rate: null,
        fx_rate_thb: null
      },
      paid_in_default_currency: null,
      paid_in_khr: null,
      paid_in_usd: null,

      change_in_default_currency: 0,
      change_in_riel: 0,
      change_in_usd: 0,
      change_in_to_currency: 0,

      time: '00:00',

      waiting: false,

      show_pdf: false,
      loadingPdf: false,
      src: null,

      isActive: 'coupon',

      paymentMethods: [],
      errors: new Errors(),
      bankProfiles: []
    }
  },

  validations: {
    model: {
      change_in_usd: {
        required,
        minValue: minValue(0)
      }
    }
  },

  created() {
    this.calculate()

    this.model.counter_id = parseInt(localStorage.getItem('counterId'))

    this.fetchResource()
  },

  mounted() {
    if (this.$refs.paid_in_default_currency) {
      this.$refs.paid_in_default_currency.focus()
    }
  },

  filters: {
    format_number(value) {
      const number = parseFloat(value)

      if (isNaN(number)) {
        return '0'
      }

      return number.toLocaleString()
    }
  },

  computed: {
    systemSettings() {
      return this.$store.state.martSale.order.systemSettings || []
    },

    systemSettingRows() {
      const settings = this.systemSettings

      if (Array.isArray(settings)) {
        return settings
      }

      if (settings && typeof settings === 'object') {
        return [settings]
      }

      return []
    },

    defaultSetting() {
      return (
        this.systemSettingRows.find(item => {
          return String(item.default_currency || '').toUpperCase() === 'THB'
        }) ||
        this.systemSettingRows[0] ||
        {}
      )
    },

    vatRate() {
      const value = parseFloat(this.defaultSetting.vat_rate)

      return isNaN(value) ? 0 : value
    },

    thbToKhrRate() {
      const rate = this.systemSettingRows.find(item => {
        return (
          String(item.from_currency || '').toUpperCase() === 'THB' &&
          String(item.to_currency || '').toUpperCase() === 'KHR'
        )
      })

      if (rate) {
        const value = parseFloat(rate.fx_rate)

        if (!isNaN(value) && value > 0) {
          return value
        }
      }

      return 0
    },

    thbToUsdRate() {
      const rate = this.systemSettingRows.find(item => {
        return (
          String(item.from_currency || '').toUpperCase() === 'THB' &&
          String(item.to_currency || '').toUpperCase() === 'USD'
        )
      })

      if (rate) {
        const value = parseFloat(rate.fx_rate)

        if (!isNaN(value) && value > 0) {
          return value
        }
      }

      return 0
    },

    exchangeRate() {
      const rate = this.thbToKhrRate

      return rate > 0 ? rate : 0
    },

    defaultCrrency() {
      return this.defaultSetting.default_currency || 'THB'
    },

    defaultCrrencySign() {
      return this.defaultSetting.default_currency_sign || '฿'
    },

    toCurrency() {
      return 'USD'
    },

    fxRateThb() {
      const rate = this.thbToUsdRate

      return rate > 0 ? rate : 0
    },

    changeInUsdErrors() {
      const errors = []

      if (!this.$v.model.change_in_usd.$dirty) {
        return errors
      }

      if (!this.$v.model.change_in_usd.required) {
        errors.push('Required')
      }

      if (!this.$v.model.change_in_usd.minValue) {
        errors.push('Invalid payment amount.')
      }

      return errors
    },

    paymentMethodOptions() {
      if (this.paymentMethods) {
        return this.paymentMethods.map(pm => ({
          value: pm.payment_method_id,
          label: pm.payment_method
        }))
      }

      return []
    },

    bankNameOptions() {
      return this.bankProfiles.map(el => ({
        value: el.bank_name,
        label: el.bank_name
      }))
    },

    accountOptions() {
      const acc = this.bankProfiles.filter(
        b => b.bank_name == this.model.bank_name
      )[0]

      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.account_number + '|' + el.account_name,
          name: el.account_name
        }))
      }

      return []
    },

    bankAccountNumber() {
      if (this.model.account_number && this.model.account_name) {
        return this.model.account_number + '|' + this.model.account_name
      }

      return ''
    },

    titleName() {
      switch (this.isActive) {
        case 'coupon':
          return 'Coupon'

        case 'credit_card':
          return 'Credit Card'

        case 'bank_transfer':
          return 'Bank Transfer'

        case 'paid_by_cheque':
          return 'Cheque'

        default:
          return ''
      }
    }
  },

  methods: {
    ...mapActions('martSale/order', ['bankProfile', 'paymentMethod']),

    onCanel() {
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },

    onOk() {
      this.show_bank = false
    },

    async onPaymentMethodChange() {
      this.model.paid_in_coupon = null
      this.model.paid_in_credit_card = null
      this.model.bank_transfer = null
      this.model.paid_by_cheque = null

      if (this.model.payment_method_id == 1) {
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = ''
      } else {
        this.show_bank = true
        this.model.bank_name = null
        this.model.account_number = null
        this.model.account_name = null
      }

      this.calculate()
    },

    fetchResource() {
      this.loading = true

      this.paymentMethod()
        .then(response => {
          this.paymentMethods = response.data
        })
        .catch(error => {
          this.notice({
            type: 'error',
            text: error.message
          })
        })
        .finally(() => {
          this.loading = false
        })

      this.fetchBank()
    },

    fetchBank() {
      this.$emit('loading', true)

      this.bankProfile()
        .then(response => {
          this.bankProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },

    bankNameChange() {
      this.model.account_number = null

      this.model.account_name = null
    },

    accountChange() {
      const account = this.accountOptions.find(
        el => el.value == this.model.account_number
      )

      if (account) {
        this.model.account_name = account.name
      }
    },

    bill() {
      this.$v.$touch()

      if (this.$v.$error) {
        return
      }

      const thbToKhr = parseFloat(this.thbToKhrRate)

      const thbToUsd = parseFloat(this.thbToUsdRate)

      if (isNaN(thbToKhr) || thbToKhr <= 0) {
        this.$toasted.error('THB to KHR conversion rate is missing.')

        return
      }

      if (isNaN(thbToUsd) || thbToUsd <= 0) {
        this.$toasted.error('THB to USD conversion rate is missing.')

        return
      }

      this.model.fx_rate = thbToKhr

      this.model.fx_rate_thb = thbToUsd

      this.model.paid_in_thb = _.round(
        parseFloat(this.paid_in_default_currency) || 0,
        2
      )

      this.model.paid_in_riel = _.round(parseFloat(this.paid_in_khr) || 0, 2)

      this.model.paid_in_usd = _.round(parseFloat(this.paid_in_usd) || 0, 2)

      this.waiting = true
      this.errors = new Errors()

      this.$store
        .dispatch(
          'martSale/order/store',
          Object.assign({}, this.model, {
            counter_id: parseInt(localStorage.getItem('counterId')),

            action_type: 'check-bill'
          })
        )
        .then(response => {
          this.$emit('close')
          this.$emit('success')

          this.$emit('generatePdf', {
            stock_out_id: response.stock_out_id,

            paperSize: this.model.paperSize
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },

    calculate() {
      this.model.stock_out_id = this.data ? this.data.stock_out_id : null

      this.model.customer_id = this.data ? this.data.customer_id : null

      this.model.products = this.data ? this.data.products : []

      const thbToKhr = parseFloat(this.thbToKhrRate) || 0

      const thbToUsd = parseFloat(this.thbToUsdRate) || 0

      const incomingFxRate =
        this.data &&
        this.data.fx_rate !== null &&
        this.data.fx_rate !== undefined
          ? parseFloat(this.data.fx_rate)
          : thbToKhr

      this.model.fx_rate = !isNaN(incomingFxRate) ? incomingFxRate : thbToKhr

      const incomingFxRateThb =
        this.data &&
        this.data.fx_rate_thb !== null &&
        this.data.fx_rate_thb !== undefined
          ? parseFloat(this.data.fx_rate_thb)
          : thbToUsd

      this.model.fx_rate_thb =
        !isNaN(incomingFxRateThb) && incomingFxRateThb > 0
          ? incomingFxRateThb
          : thbToUsd

      const inputVatRate =
        this.data &&
        this.data.vat_rate !== null &&
        this.data.vat_rate !== undefined
          ? parseFloat(this.data.vat_rate)
          : parseFloat(this.vatRate)

      this.model.vat_rate = !isNaN(inputVatRate) ? inputVatRate : 0

      if (this.defaultCrrency === 'THB') {
        const paidThb = parseFloat(this.paid_in_default_currency) || 0

        const paidKhr = parseFloat(this.paid_in_khr) || 0

        const paidUsd = parseFloat(this.paid_in_usd) || 0

        const paidCoupon = parseFloat(this.model.paid_in_coupon) || 0

        const paidCreditCard = parseFloat(this.model.paid_in_credit_card) || 0

        const bankTransferUsd = parseFloat(this.model.bank_transfer) || 0

        const bankTransferKhr = parseFloat(this.model.bank_transfer_riel) || 0

        const bankTransferThb = parseFloat(this.model.bank_transfer_thb) || 0

        const paidCheque = parseFloat(this.model.paid_by_cheque) || 0

        const discountRate = _.round(
          parseFloat(this.model.discount_rate) || 0,
          2
        )

        this.model.sub_total =
          parseFloat(this.data ? this.data.sub_total : 0) || 0

        this.model.discount_amount =
          this.model.discount_type === '฿'
            ? discountRate
            : (this.model.sub_total * discountRate) / 100

        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount

        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100

        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount

        const paidKhrInThb = thbToKhr > 0 ? paidKhr / thbToKhr : 0

        const paidUsdInThb = thbToUsd > 0 ? paidUsd / thbToUsd : 0

        const couponInThb = thbToUsd > 0 ? paidCoupon / thbToUsd : 0

        const creditCardInThb = thbToUsd > 0 ? paidCreditCard / thbToUsd : 0

        const bankTransferUsdInThb =
          thbToUsd > 0 ? bankTransferUsd / thbToUsd : 0

        const bankTransferKhrInThb =
          thbToKhr > 0 ? bankTransferKhr / thbToKhr : 0

        const chequeInThb = thbToUsd > 0 ? paidCheque / thbToUsd : 0

        const totalPaidInThb =
          paidThb +
          paidKhrInThb +
          paidUsdInThb +
          couponInThb +
          creditCardInThb +
          bankTransferUsdInThb +
          bankTransferKhrInThb +
          bankTransferThb +
          chequeInThb

        this.change_in_default_currency = _.round(
          totalPaidInThb - this.model.grand_total,
          2
        )

        this.change_in_riel = _.round(
          this.change_in_default_currency * thbToKhr,
          2
        )

        this.change_in_usd = _.round(
          this.change_in_default_currency * thbToUsd,
          2
        )

        this.change_in_to_currency = this.change_in_usd

        this.model.paid_in_thb = _.round(paidThb, 2)

        this.model.paid_in_riel = _.round(paidKhr, 2)

        this.model.paid_in_usd = _.round(paidUsd, 2)

        this.model.change_in_thb = _.round(this.change_in_default_currency, 2)

        this.model.change_in_riel = _.round(this.change_in_riel, 2)

        this.model.change_in_usd = _.round(this.change_in_usd, 2)

        this.model.fx_rate = thbToKhr

        this.model.fx_rate_thb = thbToUsd

        return
      }

      if (this.defaultCrrency === 'KHR') {
        const exchangeRate = parseFloat(this.exchangeRate) || 1

        const paidInToCurrency = _.round(
          (parseFloat(this.paid_in_to_currency) || 0) * exchangeRate,
          2
        )

        const paidCoupon = _.round(
          (parseFloat(this.model.paid_in_coupon) || 0) * exchangeRate,
          2
        )

        const paidCreditCard = _.round(
          (parseFloat(this.model.paid_in_credit_card) || 0) * exchangeRate,
          2
        )

        const bankTransfer = _.round(
          (parseFloat(this.model.bank_transfer) || 0) * exchangeRate,
          2
        )

        const bankTransferRiel = _.round(
          parseFloat(this.model.bank_transfer_riel) || 0,
          2
        )

        const paidByCheque = _.round(
          (parseFloat(this.model.paid_by_cheque) || 0) * exchangeRate,
          2
        )

        const paidDefault = _.round(
          parseFloat(this.paid_in_default_currency) || 0,
          2
        )

        const discountRate = _.round(
          parseFloat(this.model.discount_rate) || 0,
          2
        )

        this.model.sub_total =
          parseFloat(this.data ? this.data.sub_total : 0) || 0

        this.model.discount_amount =
          this.model.discount_type === '$'
            ? discountRate * exchangeRate
            : (this.model.sub_total * discountRate) / 100

        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount

        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100

        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount

        this.change_in_default_currency = _.round(
          paidDefault +
            paidInToCurrency +
            paidCoupon +
            paidCreditCard +
            bankTransfer +
            bankTransferRiel +
            paidByCheque -
            this.model.grand_total,
          2
        )

        this.change_in_to_currency = _.round(
          this.change_in_default_currency / exchangeRate,
          2
        )

        this.model.paid_in_riel = paidDefault

        this.model.paid_in_usd = _.round(
          parseFloat(this.paid_in_to_currency) || 0,
          2
        )

        this.model.change_in_riel = this.change_in_default_currency

        this.model.change_in_usd = this.change_in_to_currency

        return
      }

      if (this.defaultCrrency === 'USD') {
        const exchangeRate = parseFloat(this.exchangeRate) || 1

        const paidDefault = _.round(
          parseFloat(this.paid_in_default_currency) || 0,
          2
        )

        const paidToCurrency = _.round(
          (parseFloat(this.paid_in_to_currency) || 0) / exchangeRate,
          2
        )

        const paidCoupon = _.round(
          parseFloat(this.model.paid_in_coupon) || 0,
          2
        )

        const paidCreditCard = _.round(
          parseFloat(this.model.paid_in_credit_card) || 0,
          2
        )

        const bankTransfer = _.round(
          parseFloat(this.model.bank_transfer) || 0,
          2
        )

        const bankTransferRiel = _.round(
          (parseFloat(this.model.bank_transfer_riel) || 0) / exchangeRate,
          2
        )

        const paidByCheque = _.round(
          parseFloat(this.model.paid_by_cheque) || 0,
          2
        )

        const discountRate = _.round(
          parseFloat(this.model.discount_rate) || 0,
          2
        )

        this.model.sub_total =
          parseFloat(this.data ? this.data.sub_total : 0) || 0

        this.model.discount_amount =
          this.model.discount_type === '$'
            ? discountRate
            : (this.model.sub_total * discountRate) / 100

        this.model.total_after_discount =
          this.model.sub_total - this.model.discount_amount

        this.model.vat_amount =
          (this.model.total_after_discount * this.vatRate) / 100

        this.model.grand_total =
          this.model.total_after_discount + this.model.vat_amount

        this.change_in_default_currency = _.round(
          paidDefault +
            paidToCurrency +
            paidCoupon +
            paidCreditCard +
            bankTransfer +
            bankTransferRiel +
            paidByCheque -
            this.model.grand_total,
          2
        )

        this.change_in_to_currency = _.round(
          this.change_in_default_currency * exchangeRate,
          2
        )

        this.model.paid_in_usd = paidDefault

        this.model.paid_in_riel = _.round(
          parseFloat(this.paid_in_to_currency) || 0,
          2
        )

        this.model.change_in_usd = this.change_in_default_currency

        this.model.change_in_riel = this.change_in_to_currency

        return
      }
    }
  },

  watch: {
    isActive: {
      handler() {
        this.calculate()
      },

      deep: true
    },

    'model.discount_type': function(val) {
      if (val) {
        this.calculate()
      }
    }
  }
}
</script>

<style scoped>
.invoice {
  padding: 20px 20px 0 20px;
}

.invoice-header {
  padding: 1px;
}

.invoice .invoice-from {
  padding: 5px 20px;
}

.invoice .invoice-to {
  padding: 2px 20px;
}

.invoice .invoice-date {
  padding: 2px 20px;
}

.invoice > div:not(.invoice-footer) {
  margin-bottom: 10px;
}

.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 3px 5px;
}

.table-responsive {
  max-height: 15vh;
  overflow-x: scroll;
  overflow-y: scroll;
}

.table > thead > tr > th {
  position: sticky;
  top: 0;
  background: rgba(230, 230, 230, 1);
  z-index: 10;
}

.invoice .invoice-price .invoice-price-left {
  padding: 2px 10px;
  font-size: 15px;
}

.invoice .invoice-price .invoice-price-right {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
}

.widget-table-img {
  width: 100px;
  height: auto;
}

.payment-type {
  font-size: 2rem;
  margin: 0;
}

.payment-type > li.active a {
  color: #2d353c;
}

.payment-type > li a {
  color: #999;
}

.form-control-lg {
  background: #fffefe;
}

.payment {
  background: #f2f3f4;
  padding: 0 0 5px 5px;
}

.invoice-footer {
  padding-top: 0;
}

.btn-row .btn {
  padding: 15px 25px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}

.invoice .invoice-price .invoice-price-left .invoice-price-row .sub-price {
  padding: 0 10px;
}

.invoice .invoice-price .invoice-price-right-gray {
  padding: 10px 10px;
  font-size: 23px;
  min-width: 41%;
  background: #f2f3f4;
}
</style>
